/* BarkBurst Stil-Studio: KI-Kostüm-Vorschau (Cloudflare Worker, wenn window.BB_AI_ENDPOINT gesetzt) + lokale Stile */
(function(){
  try{sessionStorage.removeItem('bb_sticker')}catch(e){}
  var AI_ENDPOINT=window.BB_AI_ENDPOINT||'';
  var COS={'Royal Admiral':'admiral','König:in':'koenig','Astronaut':'astronaut','Pirat':'pirat','Detektiv':'detektiv','Weihnachtsheld':'weihnachten'};
  var STYLES=[['original','Original','🐶'],['pop','Pop-Art','🎨'],['comic','Comic','💥'],['sticker','Sticker','⭐'],['sunset','Sunset','🌅'],['neon','Neon','⚡'],['halftone','Raster','🔴'],['duo','Duo-Tone','🎭']];
  var INK=[27,21,48],PINK=[255,61,127],YEL=[255,210,63],CREAM=[255,247,238],MINT=[61,220,151],SKY=[90,184,255];
  function nameOf(id){if(id==='ai')return 'KI-Kostüm';for(var i=0;i<STYLES.length;i++)if(STYLES[i][0]===id)return STYLES[i][1];return id}
  function costume(){var r=document.querySelector('input[name="properties[Kostüm]"]:checked');return r?r.value:''}
  function css(){
    if(document.getElementById('bb-studio-css'))return;
    var s=document.createElement('style');s.id='bb-studio-css';
    s.textContent='.bbst-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-top:10px}.bbst-it{position:relative;margin:0;display:block;cursor:pointer}.bbst-it input{position:absolute;opacity:0;inset:0;width:100%;height:100%;margin:0;cursor:pointer}.bbst-it span{display:flex;align-items:center;gap:6px;padding:10px;background:#fff;border:3px solid #1b1530;border-radius:14px;font:800 13px/1.1 DM Sans,sans-serif;color:#1b1530;box-sizing:border-box}.bbst-it input:checked+span{background:#ffd23f;box-shadow:3px 3px 0 #ff3d7f}.bbst-it input:focus-visible+span{outline:3px solid #5ab8ff;outline-offset:2px}.bbst-it input:disabled+span{opacity:.45}.bbst-st{margin:10px 0 0;font:500 13px/1.4 DM Sans,sans-serif;color:#5a5470;min-height:18px}.bbst-ai{margin-top:10px;padding:10px 12px;border:2px dashed #1b1530;border-radius:14px;font:500 13px/1.4 DM Sans,sans-serif;color:#1b1530}.bbst-ai label{display:flex;gap:8px;align-items:flex-start;margin:0}.bbst-ai input{margin-top:3px}@media(max-width:600px){.bbst-grid{grid-template-columns:repeat(2,1fr)}}';
    document.head.appendChild(s);
  }
  function lerp(a,b,t){return [a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t]}
  function grad(t){ if(t<.45)return lerp(INK,PINK,t/.45); if(t<.8)return lerp(PINK,YEL,(t-.45)/.35); return lerp(YEL,CREAM,(t-.8)/.2); }
  function load(src){return new Promise(function(res,rej){var i=new Image();i.onload=function(){res(i)};i.onerror=rej;i.src=src;})}
  function sobel(g,w,h){
    var b=new Float32Array(w*h),m=new Float32Array(w*h),i,x,y;
    for(y=1;y<h-1;y++)for(x=1;x<w-1;x++){i=y*w+x;b[i]=(g[i]*4+g[i-1]+g[i+1]+g[i-w]+g[i+w])/8;}
    for(y=2;y<h-2;y++)for(x=2;x<w-2;x++){i=y*w+x;
      var gx=-b[i-w-1]-2*b[i-1]-b[i+w-1]+b[i-w+1]+2*b[i+1]+b[i+w+1];
      var gy=-b[i-w-1]-2*b[i-w]-b[i-w+1]+b[i+w-1]+2*b[i+w]+b[i+w+1];
      m[i]=Math.sqrt(gx*gx+gy*gy);}
    return m;
  }
  function post(v,n){return Math.round(v/255*(n-1))/(n-1)*255}
  function stylize(c,id){
    var w=c.width,h=c.height,x=c.getContext('2d'),im=x.getImageData(0,0,w,h),d=im.data,n=w*h,g=new Float32Array(n),i,p;
    for(i=0;i<n;i++){p=i*4;g[i]=.299*d[p]+.587*d[p+1]+.114*d[p+2];}
    var edge=(id==='comic'||id==='sticker'||id==='neon')?sobel(g,w,h):null;
    var cell=Math.max(10,Math.round(w/80));
    for(i=0;i<n;i++){
      p=i*4;var r=d[p],gg=d[p+1],b=d[p+2],l=g[i],o;
      if(id==='pop'){var t=Math.min(1,Math.max(0,(l-30)/190));var q=t<.25?INK:t<.5?PINK:t<.75?YEL:CREAM;o=q;}
      else if(id==='sunset'){var t2=Math.min(1,Math.max(0,(l-20)/200));o=grad(t2);}
      else if(id==='duo'){var t3=Math.min(1,Math.max(0,(l-20)/210));o=t3<.5?lerp(INK,SKY,t3*2):lerp(SKY,CREAM,(t3-.5)*2);}
      else if(id==='halftone'){var px=i%w,py=(i/w)|0,cx=(Math.floor(px/cell)+.5)*cell,cy=(Math.floor(py/cell)+.5)*cell;
        var ci=Math.min(h-1,Math.floor(cy))*w+Math.min(w-1,Math.floor(cx));var dark=1-g[ci]/255;
        var rad=cell*.72*Math.sqrt(dark),dx=px-cx,dy=py-cy;o=(dx*dx+dy*dy<rad*rad)?PINK:CREAM;}
      else if(id==='comic'||id==='sticker'){var k=id==='comic'?1.35:1.7,lv=id==='comic'?5:6;
        r=post(Math.min(255,Math.max(0,l+(r-l)*k)),lv);gg=post(Math.min(255,Math.max(0,l+(gg-l)*k)),lv);b=post(Math.min(255,Math.max(0,l+(b-l)*k)),lv);
        o=[r,gg,b];var th=id==='comic'?110:85;if(edge[i]>th)o=INK;}
      else if(id==='neon'){var e=Math.min(1,edge[i]/140);e=Math.pow(e,.7);var yy=Math.floor(i/w)/h;o=lerp(INK,lerp(PINK,MINT,yy),e);}
      else o=[r,gg,b];
      d[p]=o[0];d[p+1]=o[1];d[p+2]=o[2];
    }
    x.putImageData(im,0,0);return c;
  }
  function init(){
    var form=document.querySelector('form.bb-pp__form');
    if(!form||form.querySelector('[data-bb-studio]'))return;
    var file=form.querySelector('[data-file]');if(!file)return;
    css();
    var root=form.closest('[data-bb-editor]')||document;
    var first=file.closest('.bb-pp__step');
    var step=document.createElement('div');step.className='bb-pp__step';step.setAttribute('data-bb-studio','');
    var all=STYLES.slice();if(AI_ENDPOINT)all.unshift(['ai','KI-Kostüm','✨']);
    var h='<p class="bb-pp__label"><span class="bb-pp__num">✦</span>Vorschau-Stil <small>(optional)</small></p><div class="bbst-grid" role="radiogroup" aria-label="Stil">';
    all.forEach(function(s,i){h+='<label class="bbst-it"><input type="radio" name="bb-style" value="'+s[0]+'" disabled'+(i===0?' checked':'')+'><span><b aria-hidden="true">'+s[2]+'</b>'+s[1]+'</span></label>';});
    h+='</div>';
    if(AI_ENDPOINT)h+='<div class="bbst-ai"><label><input type="checkbox" data-ai-consent><span>Für die KI-Vorschau wird dein Foto kurz an einen KI-Dienst (Cloudflare Workers AI) übertragen und nur dafür verarbeitet. Die Vorschau zeigt einen <b>ähnlichen</b> Hund im gewählten Kostüm – das fertige Portrait zeichnen wir nach deinem Foto. Details in der <a href="/policies/privacy-policy">Datenschutzerklärung</a>.</span></label></div>';
    h+='<p class="bbst-st" data-bbst-status aria-live="polite">Lade zuerst ein Foto hoch – dann siehst du die Vorschau live auf dem Produkt.</p>';
    step.innerHTML=h;
    first.parentNode.insertBefore(step,first.nextSibling);
    var out=document.createElement('input');out.type='file';out.name='properties[Stil-Version]';out.hidden=true;out.style.display='none';out.setAttribute('data-bbst-out','');form.appendChild(out);
    var tag=document.createElement('input');tag.type='hidden';tag.name='properties[Stil]';tag.disabled=true;form.appendChild(tag);
    var status=step.querySelector('[data-bbst-status]');
    var radios=step.querySelectorAll('input[name=bb-style]');
    var consent=step.querySelector('[data-ai-consent]');
    var cache={},url=null,busy=0;
    function cur(){var r=step.querySelector('input[name=bb-style]:checked');return r?r.value:'original'}
    function setOut(blob,id,name){
      var dt=new DataTransfer();
      if(blob)dt.items.add(new File([blob],'barkburst-'+id+(blob.type==='image/jpeg'?'.jpg':'.png'),{type:blob.type||'image/png'}));
      out.files=dt.files;tag.disabled=!blob;tag.value=name||'';
    }
    function show(blob){
      var imgs=root.querySelectorAll('[data-design-photo]');
      var prev=root.querySelector('[data-preview]');
      var u=blob?URL.createObjectURL(blob):(prev?prev.src:'');
      imgs.forEach(function(im){im.src=u;im.hidden=false;});
      if(url)URL.revokeObjectURL(url);url=blob?u:null;
    }
    function toBlob(c,t,q){return new Promise(function(r){c.toBlob(r,t||'image/png',q)})}
    async function apply(id){
      var my=++busy,name=nameOf(id),key=id;
      if(id==='original'){setOut(null);show(null);status.textContent='Original-Foto. Wir zeichnen dein Portrait nach diesem Foto.';return;}
      var cv=costume(),slug=COS[cv];
      if(id==='ai'){
        if(!slug){status.textContent='Bitte wähle oben zuerst ein Kostüm.';return;}
        if(consent&&!consent.checked){status.textContent='Bitte stimme der Übertragung deines Fotos zu, dann erstellen wir die KI-Vorschau.';return;}
        key='ai:'+slug;name='KI-Kostüm '+cv;
      }
      status.textContent=id==='ai'?'KI-Vorschau wird erstellt – das dauert ca. 10 Sekunden …':'Stil wird erstellt …';
      try{
        var blob=cache[key];
        if(!blob){
          var prev=root.querySelector('[data-preview]');
          var img=await load(prev.src);
          if(id==='ai'){
            var sq=Math.min(img.naturalWidth,img.naturalHeight),c0=document.createElement('canvas');c0.width=512;c0.height=512;
            c0.getContext('2d').drawImage(img,(img.naturalWidth-sq)/2,(img.naturalHeight-sq)/2,sq,sq,0,0,512,512);
            var small=await toBlob(c0,'image/jpeg',.9);
            var fd=new FormData();fd.append('photo',small,'photo.jpg');fd.append('style',slug);
            var rs=await fetch(AI_ENDPOINT,{method:'POST',body:fd});
            if(!rs.ok)throw new Error('ai');
            blob=await rs.blob();
          } else {
            var S=1600,sc=Math.min(1,S/Math.max(img.naturalWidth,img.naturalHeight));
            var c=document.createElement('canvas');c.width=Math.round(img.naturalWidth*sc);c.height=Math.round(img.naturalHeight*sc);
            c.getContext('2d',{willReadFrequently:true}).drawImage(img,0,0,c.width,c.height);
            await new Promise(function(r){setTimeout(r,30)});
            stylize(c,id);blob=await toBlob(c);
          }
          cache[key]=blob;
        }
        if(my!==busy)return;
        setOut(blob,id==='ai'?slug:id,name);show(blob);
        status.textContent=id==='ai'?'KI-Vorschau „'+cv+'“ ist aktiv. Sie zeigt einen ähnlichen Hund – dein fertiges Portrait zeichnen wir nach deinem Foto.':'Stil „'+name+'“ ist aktiv und wird mit deiner Bestellung gespeichert.';
      }catch(e){if(my!==busy)return;status.textContent='Dieser Stil konnte nicht erstellt werden. Bitte versuche es erneut, wähle einen anderen oder nutze das Original.';var o=step.querySelector('input[value=original]');if(o)o.checked=true;setOut(null);show(null);}
    }
    step.addEventListener('change',function(e){
      if(e.target===consent){if(consent.checked&&cur()==='ai'&&file.files.length)apply('ai');return;}
      if(e.target.name!=='bb-style')return;
      apply(e.target.value);
    });
    document.querySelectorAll('input[name="properties[Kostüm]"]').forEach(function(r){r.addEventListener('change',function(){if(cur()==='ai'&&file.files.length&&!radios[0].disabled)apply('ai');});});
    file.addEventListener('change',function(){
      cache={};setOut(null);
      setTimeout(function(){
        var prev=root.querySelector('[data-preview]');
        var ok=file.files.length&&prev&&!prev.hidden;
        radios.forEach(function(r){r.disabled=!ok;});radios[0].checked=true;
        if(!ok){status.textContent='Für dieses Dateiformat gibt es keine Vorschau. Wir zeichnen dein Portrait trotzdem.';return;}
        if(cur()==='ai'){if(consent&&!consent.checked)status.textContent='Setze den Haken unten, um die KI-Vorschau mit deinem Kostüm zu erstellen.';else apply('ai');}
        else status.textContent='Wähle einen Stil – er erscheint sofort auf deinem Produkt.';
      },80);
    });
  }
  function run(){init()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('load',function(){setTimeout(run,500)});
})();
